<template>
    <div>
        <!-- middle middle section -->
        <div class="main-internal-section width-full float-l">
            <div class="container">
                <template v-if="cantAccessPage === true">
                    <div class="row">
                        <div class="chat-btm-section-main width-full float-l">
                            <!-- middle section -->
                            <div class="chat-web-section chat-user-list-main float-l width-full">
                                <h2 class="chat-page-title float-l colpie-80 color-333333 heading-text-24 line-height-28 font-bold ucase"> 
                                    Schedule Section 
                                    <span>(All times are in Sydney)</span>
                                </h2>
                                <div class="logout-btn float-r">
                                    <router-link class="btn btn-primary internal-large-btn" v-bind:to="{name: 'AddSectionScheduleTime'}">
                                        <span class="gradient"></span> Add Scheduler
                                    </router-link>
                                </div>
                                <!-- <div class="user-listing-section-web float-l width-full"> -->
                                <vue-good-table
                                    ref="listScheduleSection"
                                    mode="remote"
                                    title="Schedule Section"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="columns"
                                    :rows="rows"
                                    :pagination-options="{
                                            enabled: true,
                                            position: 'bottom',
                                            perPage: 10,
                                            dropdownAllowAll: false,
                                        }"
                                    :select-options="{
                                    enabled: true,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'Clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">
                                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                            <div :key="key" class="user-list-view">
                                                <div v-if="props.column.field == 'action'">
                                                    <router-link title="Edit Schedule Section" v-bind:to="{name: 'UpdateSectionScheduleTime', params:{id: props.row.id}}"><i class="fa fa-angle-right"></i></router-link>
                                                    <button class="btn btn-success waves-effect row-activate-btn" v-on:click.prevent="deleteSchedule(props.row.id)"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                                </div>
                                                <div v-if="props.column.field == 'sectionRoleHtml'" class='btn-center-vvg'>
                                                    <span v-html="props.formattedRow[props.column.field]"></span>
                                                </div>
                                                <div v-else>
                                                    {{props.formattedRow[props.column.field]}}
                                                </div>
                                            </div>
                                        </template>
                                    <div slot="selected-row-actions">
                                        <template>
                                            <button id="deleteGroupBtn" v-on:click.prevent="deleteSchedule(0)" class="btn btn-success waves-effect row-activate-btn">Delete</button>
                                        </template>
                                    </div>
                                </vue-good-table>
                                <!-- </div> -->
                            </div>
                            <div class="user-list-mobile float-l width-full">
                                <div class="large-btn float-l width-full">
                                    <router-link  v-bind:to="{name: 'AddSectionScheduleTime'}">
                                        Add Scheduler
                                    </router-link>
                                </div>
                                <div class="mobile-class-userlist">
                                    <!-- <div class="mobile-active-deactive-button vgt-selection-info-row__actions vgt-pull-right">
                                        <button id="deleteGroupBtn" v-on:click.prevent="activeOrInactiveState('De Activate')" class="btn btn-success waves-effect row-deactivate-btn">De Activate</button>
                                        <button id="deleteGroupBtn" v-on:click.prevent="activeOrInactiveState('Activate')" class="btn btn-success waves-effect row-activate-btn">Activate</button>
                                    </div> -->
                                    <template v-if="rows && rows.length > 0">
                                        <div :key="sectionIndex" class="user-list-section col-12 float-l relative pt_20 pb_20" v-for="(section, sectionIndex) in rows">
                                            <div class="custom-control custom-checkbox mb_3">
                                                <!-- <input type="checkbox" class="custom-control-input" id="customCheck" name="example1"> -->
                                                <label class="custom-control-label float-l width-full heading-text-16 line-height-20 color-333333 font-benton-medium pl_15" for="customCheck">
                                                    <div class="user-name-mobile">
                                                        {{section.section_name}}
                                                    </div>
                                                    <span class="color-888888 float-l width-full font-text-regular-benton heading-text-13 line-height-17 pt_3">
                                                        {{section.start_time}} - {{section.end_time}}
                                                    </span>
                                                </label> 
                                                <router-link title="Edit Schedule Section Time" v-bind:to="{name: 'UpdateSectionScheduleTime', params:{id: section.id}}"><i class="fa fa-angle-right"></i></router-link>               
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <!-- middle section -->
                    </div>
                </template>
                <template v-else>
                    <template v-if="isRequestComplete">
                        <div class="col-md-12">
                            <div class="error-template">
                                <h1>
                                    Oops!</h1>
                                <h2>
                                    403 </h2>
                                <div class="error-details">
                                    Sorry!, You don't have permission to access this page.
                                </div>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import moment from 'moment';
    import EventBus from '../event-bus';
    var contex;
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    Vue.use(VueGoodTable);

    Vue.component("app-footer", Footer);
    export default {
        name: 'ListScheduleSection',
        mixins: [commonMixins],
        data () {
            return {
                permissions: [],
                cantAccessPage: true,
                isRequestComplete: false,
                columns: [
                    {
                        label: 'Section Name',
                        field: 'section_name',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Section Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Start Time',
                        field: 'start_time',
                        filterable: false,
                        /* filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Start Time", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                    {
                        label: 'End Time',
                        field: 'end_time',
                        filterable: false,
                        /* filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "End Time", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        } */
                    },
                    {
                        field: 'action',
                        sortable: false,
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    sort: {
                        field: 'id',
                        type: 'desc',
                    },
                    page: 1,
                    perPage: 10
                },
                firstLoad: 0,
            }
        },
        watch:{
        },
        beforeMount: function () {
            contex = this;
        },
        mounted: function() {
            var self = this;
            self.loadScheduleSection();
            EventBus.$emit("headerMobileView", 'Schedule Section');
            self.isRequestComplete = false;
            // self.getPermissions(self.callback);
            self.getPermissions();
        },
        filters: {
        },
        methods: {
            deleteSchedule : function (id) {
                var self = this;
                var data;
                var use = [];

                if (id == 0) {
                    data = self.$refs['listScheduleSection'].selectedRows;
                    for (var i = 0; i < data.length; i++) {
                        use.push(self.$refs['listScheduleSection'].selectedRows[i].id)
                    }
                } else {
                    data = id;
                    use.push(id);
                }

                self.$swal({
                    title: '',
                    text: 'Are you sure that you want to delete this',
                    type: 'info',
                    confirmButtonText: 'OK',
                    showCancelButton: true,
                    // showCloseButton: true,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        var fields = {
                            id: use,
                        };
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                        };
                        self.showLoader();
                        HTTP.post("delete-schedule-section-time", fields, config)
                            .then(function (response) {
                                if (response.data.code == '200') {
                                    self.loadScheduleSection();
                                }
                                self.hideLoader();
                            })
                            .catch(function (error) {
                                self.hideLoader();
                                self.catchHandler(error, function () {});
                            });
                    }
                });
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadScheduleSection();
            },
            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadScheduleSection();
            },
            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('section_name');
                    field:('start_time');
                    field:('end_time');

                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1) {
                    this.loadScheduleSection();
                }
            },
            selectionChanged() {
                var self = this;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadScheduleSection();
            },
            loadScheduleSection: function() {
                var self = this;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };
                self.firstLoad = 1;
                self.showLoader();
                HTTP.post("list-schedle-time-for-section", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
                            if (response.data.content != "") {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                                self.filteredFlag = false;
                            }
                        }
                        self.hideLoader();
                    })
                    .catch(function (error) {
                        self.hideLoader();
                        self.catchHandler(error, function () {});
                    });
            },
            callback: function(status) {
                var self = this;
                self.isRequestComplete = true;
            }
        }
    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->


// WEBPACK FOOTER //
// src/components/SectionScheduler/ListSectionSchedulerTime.vue